import { useAppSelector } from '~/redux/hooks'

import { BootcampActivitySet } from '../types/bootcamp.types'
import { selectKudos } from '../slices/bootcamp-activity.slice'
import { getGemCountInChest, getXPCountInChest } from '../utils/bootcamp.utils'

export function useGetRewardsInChest(
  activitySet: BootcampActivitySet | undefined,
  bootcampComplexityLevel: number,
): { xp: number; gems: number; kudos: number } {
  const kudos = useAppSelector(selectKudos)

  let gemCount = 0
  let xpCount = 0

  activitySet?.difficulties.forEach((difficulty, index) => {
    gemCount += getGemCountInChest(bootcampComplexityLevel, activitySet.workLoadLevel, difficulty.difficultyLevel)

    xpCount += Math.round(
      getXPCountInChest(bootcampComplexityLevel, activitySet.workLoadLevel, difficulty.difficultyLevel) *
        (index === activitySet.difficulties.length - 1 ? 1 : 0.25),
    )
  })

  return { xp: xpCount, gems: gemCount, kudos }
}
